import script from "./ServicesTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./ServicesTable.vue?vue&type=script&setup=true&lang=ts"

import "./ServicesTable.vue?vue&type=style&index=0&id=ad0279a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ad0279a4"]])

export default __exports__